<template>
	<div>
		<header-page
			name="roles-global"
			:title="$route.meta.title"
		/>
		<RolesGlobalList
			@edit-role="editingRole"
		/>
		<ActionSidebar
			:title="titleComputed"
			v-model="slide"
		>
			<NewRoleForm
				@close-modal="closeModal"
			/>
		</ActionSidebar>
	</div>
</template>
<script>
import l from '@/shared/lib';

function closeModal() {
	this.slide = false;
	this.currentRole = {};
}

function titleComputed() {
	return l.isEmpty(this.currentRole) ? 'Nuevo Rol' : 'Editar Rol';
}

function editingRole(rol) {
	this.currentRole = { ...rol };
	this.openModal();
}

function openModal() {
	this.slide = true;
}

function data() {
	return {
		currentRole: {},
		slide: false,
	};
}

export default {
	name: 'page-global-roles',
	components: {
		ActionSidebar: () => import('@/components/shared/action-sidebar'),
		NewRoleForm: () => import('@/components/roles/new-global-role'),
		RolesGlobalList: () => import('@/components/roles/roles-global-list'),
	},
	computed: {
		titleComputed,
	},
	data,
	methods: {
		closeModal,
		editingRole,
		openModal,
	},
};
</script>


// WEBPACK FOOTER //
// src/pages/roles/page-global-roles.vue